export default [
  [`Шапка`, `Размер (см)`, `Допуск (см)`],
  [`Обхват`, `56-59`, `1`],
  [`Высота`, `28`, `1`],
  [`Ширина`, `25`, `1`]
];
